import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import store from "./store";
import "./assets/scss/fonts.scss";
import "./assets/themes/index.scss";

import VueEasymde from "vue-easymde";
import "easymde/dist/easymde.min.css";
import router from "./router";
import VueRouter from "vue-router";

// 1. Use plugin.
// This installs <router-view> and <router-link>,
// and injects $router and $route to all router-enabled child components
Vue.use(VueRouter);
Vue.component("vue-easymde", VueEasymde);
// Highlight.js languages (Only required languages)
import html from "highlight.js/lib/languages/xml";
import markdown from "highlight.js/lib/languages/markdown";

import VueHighlightJS from "vue-highlight.js";
import vClickOutside from "v-click-outside";
import VTooltip from "v-tooltip";
import vmodal from "vue-js-modal";
Vue.use(vmodal, { dialog: true });
Vue.use(VTooltip);
Vue.use(vClickOutside);
/*
 * Import Highlight.js theme
 * Find more: https://highlightjs.org/static/demo/
 */
import "highlight.js/styles/agate.css";
import "v-tooltip/dist/v-tooltip.css";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
const options = {
  // You can set your default options here
};

Vue.use(Toast, options);
Vue.config.productionTip = false;

/*
 * Use Vue Highlight.js
 */
Vue.use(VueHighlightJS, {
  // Register only languages that you want
  languages: {
    markdown,
    html,
  },
});
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
